<template>
  <Dialog class="mobile share-dialog" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="share" :showClose="true" :class="type">
    <div class="share-dialog-content">
      <img src="~@/assets/imgs/act/mwr/share/facebook.png" @click="shareToFB" alt="facebook">
      <img src="~@/assets/imgs/act/mwr/share/x.png" @click="shareToX" alt="x(twitter)">
      <img src="~@/assets/imgs/act/mwr/share/whatsapp.png" @click="shareToWhatsApp" alt="whatsapp">
      <!-- <button @click="shareToFB">facebook</button>
      <button @click="shareToX">x(twitter)</button>
      <button @click="shareToWhatsApp">whatsapp</button> -->
    </div>
  </Dialog>
</template>

<script setup>
  /* eslint-disable */
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  type: { // normal, shareDragon
    type: String,
    default: 'normal'
  }
})

const emit = defineEmits(['update:modelValue', 'shareSuccess'])

const updateModelValue = (value) => {
  emit('update:modelValue', value)
}

const shareToFB = () => {
  handleShare()
  const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href)
  window.open(url, '_blank')
}

const shareToX = () => {
  handleShare()
  const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href)
  window.open(url, '_blank')
}

const shareToWhatsApp = () => {
  handleShare()
  const url = 'https://wa.me/?text=' + encodeURIComponent(window.location.href)
  window.open(url, '_blank')
}

const handleShare = () => {
  // setTimeout(() => {
  emit('shareSuccess')
  // }, 1000)
}
</script>

<style lang="less" scoped src="./mobile_style.less"></style>

